import { useCallback, useState } from 'react';
import fleetApi from '../../services/api.service';

/**
 * Envoi en ordonnancement depuis le puits : étapes entières et/ou BL choisis
 * un par un (l'API détache ces BL dans une nouvelle étape)
 */
const useScheduleOrders = () => {
  const [isScheduling, setIsScheduling] = useState(false);

  const scheduleOrders = useCallback(
    async ({ tourPlanningIds = [], deliveryDetailIds = [], deliveryDate }) => {
      setIsScheduling(true);
      try {
        const response = await fleetApi.post('/tours-planning/schedule', {
          tours_planning_ids: tourPlanningIds,
          delivery_detail_ids: deliveryDetailIds,
          delivery_date: deliveryDate,
        });
        return response.data;
      } catch (err) {
        throw new Error(
          err?.response?.data?.message ||
            err.message ||
            "Impossible d'envoyer en ordonnancement"
        );
      } finally {
        setIsScheduling(false);
      }
    },
    []
  );

  return { scheduleOrders, isScheduling };
};

export default useScheduleOrders;
